import axios from '@axios'

export default {
    namespaced: true,
    state: {
        divisiones: [],
        subBodegas: [],
        bodInterna: [],
        procesos: [],
        tipoTransferencias: [],
        tipoTransferenciasE: [],
        validacion: null,
        mp: [],
        unidades: [],
        stock: [],
        kardex: []
    },
    getters: {
        getDivisiones(state) {
            return state.divisiones;
        },
        getSubBodegas(state) {
            return state.subBodegas;
        },
        getBodegaInterna(state) {
            return state.bodInterna;
        },
        getProcesos(state) {
            return state.procesos;
        },
        getTransferencias(state) {
            return state.tipoTransferencias;
        },
        getTransferenciasEgreso(state) {
            return state.tipoTransferenciasE;
        },
        getValidacion(state) {
            return state.validacion;
        },
        getMP(state) {
            return state.mp;
        },
        getUnidades(state) {
            return state.unidades;
        },
        getStock(state) {
            return state.stock;
        },
        getKardex(state) {
            return state.kardex;
        }
    },
    mutations: {
        setDivisiones(state, divisiones) {
            state.divisiones = divisiones;
        },
        setSubBodega(state, subBodegas) {
            state.subBodegas = subBodegas;
        },
        setBodInterna(state, bodInterna) {
            state.bodInterna = bodInterna;
        },
        setProcesos(state, procesos) {
            state.procesos = procesos;
        },
        setTransferencias(state, tipoTransferencias) {
            state.tipoTransferencias = tipoTransferencias;
        },
        setTransferenciasEgreso(state, tipoTransferenciasE) {
            state.tipoTransferenciasE = tipoTransferenciasE;
        },
        setValidacion(state, validaGuia) {
            state.validacion = validaGuia;
        },
        setMP(state, mp) {
            state.mp = mp;
        },
        setUnidades(state, unidades) {
            state.unidades = unidades;
        },
        setStock(state, stock) {
            state.stock = stock;
        },
        setKardex(state, kardex) {
            state.kardex = kardex;
        }
    },

    actions: {
        fetchDivisiones({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/transferencias/divisiones")
                    .then(response => {
                        commit("setDivisiones", response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchSubBodegas({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/transferencias/subBodegas?co_division=${data}`;
                axios
                    .get(url)
                    .then(response => {
                        commit("setSubBodega", response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchBodegaInterna({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/transferencias/bodegaInterna?Id=${data}`;
                axios
                    .get(url)
                    .then(response => {
                        commit("setBodInterna", response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchProcesos({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/transferencias/procesos?co_bodInterna=${data}`;

                axios
                    .get(url)
                    .then(response => {
                        commit("setProcesos", response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchTransferencias({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/transferencias/tipoTransferencias")
                    .then(response => {
                        commit("setTransferencias", response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchTransferenciasEgreso({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/transferencias/tipoTransferenciasEgreso")
                    .then(response => {
                        commit("setTransferenciasEgreso", response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        postAgregarTransferencia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        "/api/auth/transferencias/GuardarProcesoFresco/", data
                    )
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchValidarGuias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/transferencias/validarGuia/", data)
                    .then(response => {
                        commit("setValidacion", response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchMP({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/transferencias/materia")
                    .then(response => {
                        commit("setMP", response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchUnidades({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/transferencias/unidades")
                    .then(response => {
                        commit("setUnidades", response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchStock({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/transferencias/stock?co_materia=${data}`;
                axios
                    .get(url)
                    .then(response => {
                        commit("setStock", response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchKardex({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/transferencias/kardex", data)
                    .then(response => {
                        commit("setKardex", response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
    }
};